import { render, staticRenderFns } from "./company-notes-widget.vue?vue&type=template&id=7a8851e2&"
import script from "./company-notes-widget.vue?vue&type=script&lang=js&"
export * from "./company-notes-widget.vue?vue&type=script&lang=js&"
import style0 from "./company-notes-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports